import React from 'react';

import { useTouchpointData } from 'common/components/TouchpointEditor/contexts/TouchpointDataContext';
import { usePreview } from 'common/components/TouchpointEditor/hooks/usePreview';

import Button from '../Button';

export default function ButtonWithPreview(props) {
    const { event } = useTouchpointData();
    const { shouldPreview } = usePreview({ event });

    return <Button {...props} replace={shouldPreview} />;
}

ButtonWithPreview.splash = { ...Button.splash };
